import styled from 'styled-components';
import { number, string } from 'prop-types';
import { Modal } from 'react-router-modal';
import { IconButton } from '@perch-labs/shrike';

export const StyledModalHeader = styled.div`
  display: none;
  padding-bottom: 48px;
  text-align: right;
  display: flex;
  justify-content: flex-end;
`;

export const CloseButton = styled(IconButton).attrs({
  margin: { right: '2px', top: '2px' },
})`
  display: block;
  top: 0;
  right: 0;
  position: absolute;
`;

export const StyledModal = styled(Modal)`
  background: ${props => props.theme.colors.background.primary};
  border-radius: 8px;
  text-align: ${props => props.textAlign};
  position: fixed;
  width: ${props => props.width}px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 32px);
  overflow: auto;
  ${props => props.theme.media.xsmall`
    border-radius: 0;
    height: 100%;
    left: 0;
    overflow: auto;
    top: 0;
    transform: initial;
    width: 100%;
    max-height: 100%;
  `};
`;

export const StyledModalContent = styled.div`
  padding: 24px;

  ${props => props.theme.media.xsmall`
    padding-bottom: 40px;
  `}
`;

Modal.propTypes = {
  textAlign: string,
  width: number,
};

Modal.defaultProps = {
  textAlign: 'center',
  width: 450,
};
